import { render, staticRenderFns } from "./alterar-senha.vue?vue&type=template&id=2d20d40a&"
import script from "./alterar-senha.vue?vue&type=script&lang=js&"
export * from "./alterar-senha.vue?vue&type=script&lang=js&"
import style0 from "./alterar-senha.vue?vue&type=style&index=0&id=2d20d40a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports